module.exports = __webpack_public_path__ + "static/img/Rectangle 2 .8476e3aa.png";